import 'twin.macro';
import { SubHeader } from '@teetsh/app/src/components/SubHeader';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useSchoolyears from 'queries/schoolyears/useSchoolyears';
import { Schoolyear } from 'types/schoolyear';
import { ClockIcon } from '@heroicons/react/24/outline';
import ButtonLink from 'components/Buttons/Link';
import FadeIn from 'components/Transitions/FadeIn';

export function shouldDisplaySubHeader(schoolyears: Schoolyear[]) {
  const schoolyearsWithZone = schoolyears.filter(
    s =>
      s.zone && s.zone?.id !== 'autre' && s.zone?.id !== 'nouvelle-caledonie',
  );
  if (schoolyearsWithZone.length === 0) {
    return false;
  }

  const nextYear = schoolyears?.find(s => s.year >= 2026);
  return !nextYear;
}

export function NewSchoolyearHeader() {
  const { data } = useSchoolyears(false);
  const [t] = useTranslation(['common']);
  if (!shouldDisplaySubHeader(data || [])) {
    return null;
  }
  return (
    <FadeIn>
      <SubHeader tw="bg-brand-intense" data-testid="new-schoolyear-header">
        <div tw="flex justify-center items-center text-white text-base">
          <div tw="flex items-center mr-3 text-base font-semibold">
            <div tw="mr-3">
              <ClockIcon tw="h-5 w-5" aria-hidden="true" />
            </div>
            <div tw="mr-6">{t('common:timeToCreateNewSchoolyear')}</div>
            {/* This is a custom button, as it appears over a "dark" background, so it should be reversed */}
            <ButtonLink
              to="/mes-annees-scolaires/new"
              tw="bg-neutral-supershy text-brand-intense hover:bg-neutral-supershy/90 active:bg-neutral-supershy/80 border border-transparent transition-colors duration-150 ease-in-out"
              small
            >
              {t('common:createNewSchoolyear')}
            </ButtonLink>
          </div>
        </div>
      </SubHeader>
    </FadeIn>
  );
}
